import { Component, OnInit, EventEmitter } from '@angular/core';
import { GlobalVariableService } from "../../../common/variables/global-variable";
import { GlobalService } from "../../../common/services/global.service";
import { TranslateService } from "../../../common/variables/translate-service";
import { SlimScrollEvent } from 'ngx-slimscroll';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { cloneDeep } from "lodash";
import { SC_Input } from '../../../common/input/SC_Input';
import { ItemListGetInput, ItemListGetData, ItemListGetOutput } from '../../../common/api/ItemListGet';
import { ItemListPrintInput, ItemListPrintOutput } from '../../../common/api/ItemListPrint';
import { ItemListToCartInput, ItemListToCartOutput } from '../../../common/api/ItemListToCart';
import { ProjectGetData } from '../../../common/api/ProjectGet';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'sen-app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss']
})

export class ItemListComponent implements OnInit {
  scrollEvents: EventEmitter<SlimScrollEvent>;
  selectedProject$: Observable<ProjectGetData[]>;
  selectedProjectArray: ProjectGetData;
  selectedProjectUnSubscribe: Subscription;
  projectItemList: ItemListGetData;

  constructor(
    public global: GlobalVariableService,
    public translate: TranslateService,
    public globalService: GlobalService,
    private store: Store<any>,
    private _snackBar: MatSnackBar) {
    this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
    this.selectedProjectUnSubscribe = this.selectedProject$.subscribe((data: any) => {
      this.selectedProjectArray = cloneDeep(data);
    })
  }

  ngOnInit(): void {
    this.getProjectItemList();
  }

  ngOnDestroy() {
    this.global.targetPath = '';
    this.selectedProjectUnSubscribe.unsubscribe();
  }

  getProjectItemList() {
    const qParam: ItemListGetInput = {
      cmd: this.global.ItemListGet,
      projectID: SC_Input.sProject.selectedProject.id
    }
    this.globalService.getData(qParam).subscribe((data: ItemListGetOutput) => {
      if (data && data.ok) {
        this.projectItemList = data.ok.data;
      }
    });
  }

  pdfExport() {
    const invPlanItems: any = this.projectItemList.inverterPlanItems;
    if(invPlanItems.length == 0){
      this._snackBar.open(this.translate.getLng('INVALID_OR_NO_INVERTERPLAN'));
    }else{
      this.showPDF();
    }
  }

  showPDF(){
    const qParam: ItemListPrintInput = {
      cmd: this.global.ItemListPrint,
      projectID: SC_Input.sProject.selectedProject.id
    }
    this.globalService.getData(qParam).subscribe((data: ItemListPrintOutput) => {
      if (data && data.ok) {
        window.open(data.ok.data.url);
      }
    });
  }

  // addToCart() {
  //   const qParam: ItemListToCartInput = {
  //     cmd: this.global.ItemListToCart,
  //     projectID: SC_Input.sProject.selectedProject.id
  //   }
  //   this.globalService.getData(qParam).subscribe((data: ItemListToCartOutput) => {
  //     if (data && data.ok) {
  //       window.open(`${window.location.origin}/${data.ok.data.url}`);
  //     }
  //   });
  // }

  addToCart() {
    const items = this.projectItemList.projectItems.items;
    let projectName = "";
    if (this.projectItemList.projectItems.name) {
      projectName = this.projectItemList.projectItems.name;
    }

    let params = `projectName=${encodeURIComponent(projectName)}`;
    for (const item of items) {
      params += `&i[]=${encodeURIComponent(item.senItemID)};${item.quantity}`;
    }
    window.open(`https://www.sen.de/checkout/cart/from-soldraft?${params}`);
  }

}

